import { ChangeDetectorRef, Component, Input, OnChanges, OnInit, SimpleChanges } from "@angular/core";
import { environment } from "src/environments/environment";
import { CommonService } from "src/app/shareModule/services/common.service";
import { CustomerService } from "src/app/shareModule/services/customer.service";

@Component({
  selector: 'app-product-review',
  templateUrl: './product-review.component.html',
  styleUrls: ['./product-review.component.scss']
})
export class ProductReviewComponent implements OnInit, OnChanges {
  imgUrl = environment.ImageUrl;
  constructor(
    // private local: LocalServiceService,
    private cdr: ChangeDetectorRef,
    private customerService: CustomerService,
    private commonService: CommonService
  ) { }

  @Input() categoryName: string = '';
  @Input() subRegionName: string = '';
  @Input() categoryId: Array<number> = [];
  @Input() isParent: boolean = false;
  @Input() productIds: Array<number> = [];

  public productReviews: Array<any> = [];

  ngOnInit() {
    console.log(this.categoryName, this.subRegionName, this.categoryId, "PRODUCT REVIEW");
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.categoryName || changes.subRegionName || changes.categoryId) {
      if (this.categoryName && this.categoryId?.length && (!this.isParent || this.subRegionName)) {
        this.getProductReviews();
      }
    }

    if (changes.subRegionName) {
      this.cdr.detectChanges();
    }

    if (changes.productIds && this.productIds?.length) {
      this.getProductReviews();
    }
  }

  ngOnDestroy(): void {
    // Clear all intervals
  }

  public getProductReviews() {
    this.customerService.getProductReviews({
      subRegionName: this.subRegionName,
      categoryId: this.categoryId,
      productIds: this.productIds
    }).subscribe((res) => {
      this.productReviews = res.body;
      this.cdr.detectChanges();
    })
  }

}